import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import ServiceDetailPage from "../pages/services/detail/page";
import AboutPage from "../pages/about/page";
import LakeForestLocationPage from "../pages/location/lake-forest/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/services/:slug",
    element: <ServiceDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/location/lake-forest",
    element: <LakeForestLocationPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
